module.exports = __webpack_public_path__ + "img/14.5667f192.jpg";